import Flickity from "flickity";
import { FlickityDotsOptions } from "./flickity-dots-options";
import { useFlickityDots } from "./use-flickity-dots";

export interface FlickityPatchedOptions extends Flickity.Options {
    dotsOptions?: FlickityDotsOptions;
}

/**
 * @deprecated Instead use KeenSlider in new components
 */
export class FlickityPatched extends Flickity {
    dots: ReturnType<typeof useFlickityDots>;
    dotsRoot: HTMLElement = null;

    constructor(selector: string | Element, options?: FlickityPatchedOptions) {
        super(selector, options);
        this.dotsRoot = options?.dotsOptions?.rootEl;

        this.on("dragStart", () => {
            (this.cells as any[]).forEach((slide) => (slide.element.style.pointerEvents = "none"));
        });
        this.on("dragEnd", () => (this.cells as any[]).forEach((slide) => (slide.element.style.pointerEvents = "all")));
        this.on("destroy", () => {
            if (this.dots) this.dots.destroy();
        });

        if (options.dotsOptions) {
            this.dots = useFlickityDots(this, options.dotsOptions);
        }
    }

    // The following two methods fix the error that Flickity throws when there is different parent for dotsOptions and Carousel
    deactivatePageDots() {
        try {
            // Try to call flicity deactivatePageDots first
            Object.getPrototypeOf(Object.getPrototypeOf(this)).deactivatePageDots();
        } catch (e) {
            console.warn("Flickity deactivatePageDots failed calling its override.");
            const superDeactivatePageDot = (this as any).pageDots.deactivate.bind({
                holder: this.dotsRoot.querySelector(".flickity-page-dots"),
                unbindStartEvent: () => {
                    // Could not figure out what this was supposed to do. So there is just console.log to prevent TS error.
                    console.log("unbidStart");
                },
                parent: { element: this.dotsRoot },
            });
            superDeactivatePageDot();
        }
    }

    deactivatePrevNextButtons() {
        try {
            // Try to call flicity deactivatePrevNextButtons first
            Object.getPrototypeOf(Object.getPrototypeOf(this)).deactivatePrevNextButtons();
        } catch (e) {
            console.warn("Flickity deactivatePrevNextButtons failed calling its override.");
            const superDeactivatePrevButton = (this as any).prevButton.deactivate.bind({
                element: (this as any).prevButton.element,
                unbindStartEvent: () => {
                    // Could not figure out what this was supposed to do. So there is just console.log to prevent TS error.
                    console.log("unbidStart");
                },
                parent: { element: this.dotsRoot },
            });
            const superDeactivateNextButton = (this as any).prevButton.deactivate.bind({
                element: (this as any).nextButton.element,
                unbindStartEvent: () => {
                    // Could not figure out what this was supposed to do. So there is just console.log to prevent TS error.
                    console.log("unbidStart");
                },
                parent: { element: this.dotsRoot },
            });
            superDeactivatePrevButton();
            superDeactivateNextButton();
        }
    }

    // FIX iOS 15 issues - when dragging, page moves
    // see https://github.com/metafizzy/flickity/issues/1177#issuecomment-981194285
    // can be removed when flickity fixes https://github.com/metafizzy/flickity/issues/1196
    resize() {
        if (!(this as any).isAnimating) {
            super.resize();
        }
    }
}
